import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'

const getConfig = (metaName: string): string | undefined =>
  document.querySelector(`meta[name="${metaName}"]`)?.getAttribute('content') ?? undefined

const userId = getConfig('x-pt-user-id') ?? undefined
const userName = getConfig('x-pt-user-name') ?? undefined
const userEmail = getConfig('x-pt-user-email') ?? undefined

// #region Datadog RUM

const serviceName = getConfig('x-dd-service') ?? 'playtomic-coaches'
const env = getConfig('x-dd-env') ?? 'dev'
const version = getConfig('x-dd-version') ?? 'unknown'
const applicationId = getConfig('x-dd-rum-application-id')
const clientToken = getConfig('x-dd-rum-client-token')

if (
  // If we are missing any of these two we can't init the RUM SDK
  applicationId &&
  clientToken
) {
  datadogRum.init({
    applicationId: applicationId,
    clientToken: clientToken,
    site: 'datadoghq.eu',
    service: serviceName,
    env: env,
    version: version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100, // << FIXME: consider lower this value
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: false })],
  })

  datadogRum.setUser({
    id: userId,
    email: userEmail,
    name: userName,
  })
}

// #endregion
